// import components
import { Drawer } from 'components/shared';
import { LinkPlanUnitDetailsLoaderFeedback } from './LinkPlanUnitDetailsLoaderFeedback';

// import hooks
import { useTranslation } from 'react-i18next';
import React from 'react';

// import types
import { PlanUnit, PlanUnitLink } from '../types';

// import utils
import { HierarchyPlanUnit } from './utils/treeHierarchy';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedRow: PlanUnit;
  mode?: PlanUnitLink;
  hierarchy: PlanUnit[] | HierarchyPlanUnit[] | undefined;
  hasReferenceDate?: boolean;
}

export const LinkPlanUnitDrawer: React.FC<Props> = ({
  open,
  onClose,
  selectedRow,
  mode,
  hierarchy,
  hasReferenceDate = false
}) => {
  const { t } = useTranslation();

  const modeLabel = t(mode ?? '');
  const title = `${modeLabel?.[0]?.toUpperCase()}${modeLabel?.slice(1)}`;

  return (
    <Drawer open={open} onClose={onClose} title={t('linkTo', { mode: title })}>
      <LinkPlanUnitDetailsLoaderFeedback
        onClose={onClose}
        mode={mode}
        selectedRow={selectedRow}
        hierarchy={hierarchy}
        hasReferenceDate={hasReferenceDate}
      />
    </Drawer>
  );
};
